import { z } from "zod/v4";

const BundleDataSchema_ = z.object({
  childData: z.array(z.object({ price: z.string(), variantId: z.string() })),
});

export const BundleDataSchema: z.ZodType<BundleData> = BundleDataSchema_;
export interface BundleData extends z.infer<typeof BundleDataSchema_> {}
